module.exports = __webpack_public_path__ + "img/AL802-1-EN.3078597d.jpg";